import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Panel } from "@/components/shared";
import { api, errMsg, useApi } from "@/lib/api";

export function MarginsPanel({ onSaved }) {
  const { data } = useApi("/settings/pricing");
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF((cur) => cur || { defaultMarginPct: data.defaultMarginPct, minMarginPct: data.minMarginPct, amc: { ...data.amcRates } }); }, [data]);
  if (!f) return null;
  const save = async () => {
    try { await api.put("/settings/margins", { defaultMarginPct: +f.defaultMarginPct, minMarginPct: +f.minMarginPct, amcRatesPct: Object.fromEntries(Object.entries(f.amc).map(([k, v]) => [k, +v])) }); toast.success("Margins saved"); onSaved?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel title="Profit margins" >
      <div className="p-5 grid sm:grid-cols-2 gap-5">
        <div className="space-y-1.5"><Label>Default profit margin %</Label>
          <Input type="number" value={f.defaultMarginPct} onChange={(e) => setF({ ...f, defaultMarginPct: e.target.value })} data-testid="default-margin-input" />
          <p className="text-xs text-muted-foreground">Pre-fills the taxable sales value when a product is added to a quotation (purchase price + this markup).</p></div>
        <div className="space-y-1.5"><Label>Minimum profit margin %</Label>
          <Input type="number" value={f.minMarginPct} onChange={(e) => setF({ ...f, minMarginPct: e.target.value })} data-testid="min-margin-input" />
          <p className="text-xs text-muted-foreground">Quotations below this margin can't be saved. Sales staff only see "Quote value is too low".</p></div>
        <div className="sm:col-span-2 space-y-2"><Label>GN Privilege package rates (% of taxable quote value, + 18% GST)</Label>
          <div className="grid grid-cols-3 gap-3">{["1Y", "2Y", "3Y"].map((k) => (
            <div key={k} className="space-y-1"><span className="text-xs text-muted-foreground">{k[0]} {k === "1Y" ? "year" : "years"}</span>
              <Input type="number" value={f.amc[k]} onChange={(e) => setF({ ...f, amc: { ...f.amc, [k]: e.target.value } })} data-testid={`amc-rate-${k}-input`} /></div>))}</div></div>
        <div className="sm:col-span-2"><Button onClick={save} data-testid="save-margins-button">Save pricing rules</Button></div>
      </div>
    </Panel>
  );
}
